import { OnInit } from '@angular/core';
import { ICON_MAPPING } from '../shared/side-nav/side-nav.component';
import { Table } from '../shared/types';
import { ActivatedRoute, Router } from '@angular/router';
import { CaptainService } from '../captain.service';
import { FilterService } from '../filter.service';
import { HelperService } from '../helper.service';
import { EntityService } from 'src/app/entity.service';
import { setServiceGroups } from 'src/app/shared/constants';
var CaptainDetailsComponent = /** @class */ (function () {
    function CaptainDetailsComponent(route, router, captainService, filterService, entityService) {
        this.route = route;
        this.router = router;
        this.captainService = captainService;
        this.filterService = filterService;
        this.entityService = entityService;
        this.userInfo = this.accessCookie('user');
        this.userDetails = JSON.parse(this.userInfo);
        this.roles = this.accessCookie('Roles').split(',');
        this.toggleableDetails = 'Order Details';
        this.captainDetailsToggleableHeaders = [
            'Order Details',
            'Activity Logs',
            'Bulk Action Logs',
            'Ticket Details',
            'Rapido Pay Logs',
            'Complaints By Customer',
            'Subscription Details',
            'Customer Complaints against Captain',
            'Call Logs',
            'FM Breaches',
            'Propagation Events',
            'Access Fee Transactions',
            'Gem Transactions',
            'Dues Transactions',
            'Available Subscriptions'
        ];
        this.ICON_MAPPING = ICON_MAPPING;
        this.dataReceived = false;
        this.filterComponents = [];
        this.showFilters = false;
    }
    CaptainDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.defineFilters();
        this.loadSubServiceTypes();
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
        var id = this.route.snapshot.paramMap.get('id');
        if (!id) {
            id = this.route.snapshot.queryParamMap.get('phone');
        }
        if (!id) {
            return;
        }
        this.id = HelperService.decode(id);
        this.entityService.getEntityByNumber(this.id, 'SEARCH_CAPTAIN_MOBILE', this.userDetails['emailId'], this.userDetails['_id'], this.roles).subscribe(function (data) {
            _this.captainDetails = data;
            _this.deviceId = data.device && data.device.deviceId;
            _this.captainId = data && data['_id'];
            _this.userId = data && data['userId'] && data['userId']['_id'] || '';
            _this.mode = data.modeId && data.modeId.mode;
            _this.captainService.captainLiveStat(_this.captainId)
                .toPromise()
                .then(function (data) {
                _this.liveLocation = data.riderLocation && data.riderLocation.location;
            })
                .finally(function () {
                var _a;
                if (_this.liveLocation) {
                    _a = _this.liveLocation, _this.lng = _a[0], _this.lat = _a[1];
                }
                /**
                 * Prefer riderId (captain _id) for these endpoints. Some environments/backends still expect userId
                 * for a subset of captains, so we fallback to userId only if the primary call returns empty.
                 */
                var primaryId = _this.captainId;
                var fallbackId = _this.userId;
                _this.captainService.getCaptainAllRateCards(primaryId, _this.lat, _this.lng).subscribe(function (rateCardData) {
                    if (rateCardData && Object.keys(rateCardData).length) {
                        _this.captainAllRateCard = rateCardData;
                        return;
                    }
                    if (fallbackId && fallbackId !== primaryId) {
                        _this.captainService.getCaptainAllRateCards(fallbackId, _this.lat, _this.lng).subscribe(function (fallbackRateCardData) {
                            if (fallbackRateCardData && Object.keys(fallbackRateCardData).length) {
                                _this.captainAllRateCard = fallbackRateCardData;
                            }
                        });
                    }
                });
                _this.captainService.getEarningModelRecommendations(primaryId, _this.lat, _this.lng).subscribe(function (earningModelRecommendations) {
                    if (earningModelRecommendations && Object.keys(earningModelRecommendations).length) {
                        _this.earningModelRecommendations = earningModelRecommendations;
                        return;
                    }
                    if (fallbackId && fallbackId !== primaryId) {
                        _this.captainService.getEarningModelRecommendations(fallbackId, _this.lat, _this.lng).subscribe(function (fallbackEarningModelRecommendations) {
                            if (fallbackEarningModelRecommendations && Object.keys(fallbackEarningModelRecommendations).length) {
                                _this.earningModelRecommendations = fallbackEarningModelRecommendations;
                            }
                        });
                    }
                });
            });
        });
    };
    CaptainDetailsComponent.prototype.loadSubServiceTypes = function () {
        // Load once on captain page open; reopen/reload this page for latest values.
        this.entityService.getSubServiceTypes().subscribe(function (subServiceTypes) {
            setServiceGroups(subServiceTypes);
        });
    };
    CaptainDetailsComponent.prototype.captainLevelDisplayName = function (name) {
        this.captainLevelName = name;
    };
    CaptainDetailsComponent.prototype.headersToggled = function (toggledHeader) {
        this.toggleableDetails = toggledHeader;
    };
    CaptainDetailsComponent.prototype.defineFilters = function () {
        this.filterComponents = [
            {
                type: 'searchable-dropdown',
                title: 'City',
                values: ['a', 'b', 'c'],
                default: '',
                key: 'incentive-city'
            },
            {
                type: 'searchable-dropdown',
                title: 'Services',
                values: ['a', 'b', 'c'],
                default: '',
                key: 'incentive-services'
            },
            {
                type: 'calendar',
                title: '',
                values: [],
                default: '',
                key: 'incentive-dates'
            },
            {
                type: 'radio-button',
                title: 'Status',
                values: ['Both', 'Active', 'Inactive'],
                default: '',
                key: 'incentive-status'
            }
        ];
        this.dataReceived = true;
    };
    // filterToggle() {
    //   this.showFilters = !this.showFilters;
    // }
    CaptainDetailsComponent.prototype.listen = function (events) {
        // console.log(events);
    };
    CaptainDetailsComponent.prototype.clearFilters = function () {
        var _this = this;
        this.dataReceived = false;
        setTimeout(function () {
            _this.dataReceived = true;
        }, 200);
    };
    CaptainDetailsComponent.prototype.applyFilters = function (event) {
        // console.log(event);
    };
    CaptainDetailsComponent.prototype.accessCookie = function (cookieName) {
        var name = cookieName + '=';
        var allCookieArray = document.cookie.split(';');
        for (var i = 0; i < allCookieArray.length; i++) {
            if (allCookieArray[i]) {
                var cookieItem = allCookieArray[i].trim();
                if (cookieItem.indexOf(name) === 0) {
                    return cookieItem.substring(name.length, cookieItem.length);
                }
            }
        }
        return '';
    };
    return CaptainDetailsComponent;
}());
export { CaptainDetailsComponent };
